<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <side-bar
      :background-color="sidebarBackground"
      short-title="Resimple"
      title="Resimple"
    >
      <template slot="links">
        <template v-for="modulo in modules">
          <sidebar-item v-bind:key="modulo.EntityID" :link="{Name: modulo.Name, Icon: modulo.Icon, Action: modulo.Action, Children: modulo.Children}" />
        </template>
      </template>
    </side-bar>


    <div class="main-content" :data="sidebarBackground">
      <dashboard-navbar></dashboard-navbar>

      <div @click="toggleSidebar">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
        <content-footer v-if="!$route.meta.hideFooter"></content-footer>
      </div>
    </div>
  </div>
</template>
<script>
  import DashboardNavbar from './DashboardNavbar.vue';
  import ContentFooter from './ContentFooter.vue';
  import { FadeTransition } from 'vue2-transitions';
  
  import 'nprogress/nprogress.css';
  
  import axiosHelpers from '@/helpers/axiosHelpers';

  export default {
    name: 'DashboardLayout',
    components: {
      DashboardNavbar,
      ContentFooter,
      FadeTransition
    },
    data() {
      return {
        sidebarBackground: 'vue', //vue|blue|orange|green|red|primary,
        modules : []
      };
    },
    methods: {
      toggleSidebar() {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false);
        }
      },
      filterModules(moduleList)
      {
          var filteredModuleList = [];
          moduleList.forEach(m => {

              if(m.ModuleTypeID == 2 || m.Action != null)
              {
                var moduleItem = {
                  EntityID: m.EntityID,
                  Name: m.Name,
                  Icon: m.Icon,
                  Action: m.Action,
                  ModuleTypeID: m.ModuleTypeID,
                  ParentID: m.ParentID,
                  Order: m.Order
                }

                filteredModuleList.push(moduleItem);
              }
            });

          return filteredModuleList;
      },
      filterModulesByParent(moduleList, parentID)
      {
          var filteredModuleList = [];
          moduleList.forEach(m => {

              if((m.ModuleTypeID == 1 && m.Action != null && m.ParentID != null) || m.ModuleTypeID == 2)
              {
                if(m.ParentID == parentID)
                {
                  var moduleItem = {
                    EntityID: m.EntityID,
                    Name: m.Name,
                    Icon: m.Icon,
                    Action: m.Action,
                    Children: [],
                    ModuleTypeID: m.ModuleTypeID,
                    ParentID: m.ParentID,
                    Order: m.Order
                  }

                  // -- 2 Son aquellos que tienen asociados subitems
                  // -- 1 Son items de menu que apuntan a una pagina en si
                  if(m.ModuleTypeID == 2)
                  {
                      var children = this.filterModulesByParent(moduleList, m.EntityID);
                      moduleItem.Children = children;
                  }

                  filteredModuleList.push(moduleItem);
                }
              }
            });

            filteredModuleList.sort(function(a, b){return a.Order-b.Order})

            return filteredModuleList;
      },
    },
    beforeMount: function(){
        let context = this;

        if(!context.$store.getters.HasModules)
        {
          axiosHelpers.axiosGet('Account/GetModules', {}, this, function(data){ 
            context.$store.dispatch("initModules", context.filterModules(data.ResponseVM.List));
            context.modules = context.filterModulesByParent(context.$store.getters.ModuleList, null);
          });
        }
        else
        {
          context.modules = context.filterModulesByParent(context.$store.getters.ModuleList, null);
        }
    }
  };
</script>
<style lang="scss">
</style>
